(function () {
  $('[name="image-popup"]').on("click", function () {
    const image = $(this).attr("data-image");
    const text = $(this).attr("data-text");
    const url = $(this).attr("data-url");
    const title = $(this).attr("data-title");
    const clientWidth = document.body.clientWidth;
    const contant = `<div class="popupbox popupbox-affirmation"> 
                    <div class="popupbox-overlay" name="close"></div>              
                    <div class="popupbox-con ${
                      clientWidth > 780 ? "fix-width" : ""
                    }">                
                        <!-- 内容区域 -->                
                        <div class="con-modelbox">                   
                            <div class="banner-box">                     
                            <img src="${image}">                   
                            </div>                  
                            <div class="con-modelbox-title">${title}</div>                                        
                            <div class="p1">${text}</div>                                      
                            <a class="read-more" href="${url}">Read More</a>                 
                        </div>                 
                            <!-- 删除区域 -->                 
                        <div class="con-close-btn" name="close">                   
                            <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_76dbb0f5-a8cd-48e1-b4b1-ceea4fa659f1.png?v=1658907695">                 
                        </div>               
                    </div>             
                </div>`;

    $("body").append(contant);

    $("[name='close']").on("click", function () {
      $(".popupbox").remove();
    });
  });

  $(".menu-list-title").on('click',function(){
    console.log($(this).find('.title-menu-btn'))
    const openClose = $(this).find('.title-menu-btn').find('.hidden')
    const isOpen = $(openClose).hasClass('btn-close')
    openClose.removeClass('hidden').siblings().addClass('hidden')
    if(isOpen){
      $(this).siblings().removeClass('hidden')
    }else{
      $(this).siblings().addClass('hidden')
    }
  })

  var Testimonial = {
        $elem: null,
        maxIndex: 0,
        timer: false,
        init: function init($elem) {
            this.$elem = $elem;
            this.maxIndex = $elem.find('.testimonials__image').length - 1;
            this.setHeight();
            $(window).resize(function() {
                Testimonial.setHeight();
            });
            $elem.find('.testimonials__image').click(function() {
                Testimonial.resetTimer();
                Testimonial.goto($(this).data('testimonial'));
            });
            $elem.find('.testimonials__image').mouseenter(function() {
                Testimonial.resetTimer();
                Testimonial.goto($(this).data('testimonial'));
            });
            this.setTimer();
        },
        setHeight: function setHeight() {
            $('.testimonials__quote-section').css('height', '');
            $('.testimonial').css('display', 'block');
            var maxHeight = 0;
            $('.testimonials__quote-section').each(function() {
                var height = $(this).outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            $('.testimonial').css('display', '');
            $('.testimonials__quote-section').css('height', maxHeight + 'px');
        },
        setTimer: function setTimer() {
            this.timer = setInterval(function() {
                Testimonial.next();
            }, 5000);
        },
        resetTimer: function resetTimer() {
            clearInterval(this.timer);
            this.setTimer();
        },
        next: function next() {
            if (window.testimonialPause) {
                return;
            }
            var targetIndex = this.getCurrentIndex() == this.maxIndex ? 0 : this.getCurrentIndex() + 1;
            this.goto(targetIndex);
        },
        getCurrentIndex: function getCurrentIndex() {
            return this.$elem.find('.testimonials__image--active').data('testimonial');
        },
        goto: function goto(index) {
            this.$elem.find('.testimonials__image--active').removeClass('testimonials__image--active');
            this.$elem.find('.testimonial--active').removeClass('testimonial--active');
            this.$elem.find('.testimonials__image[data-testimonial="' + index + '"]').addClass('testimonials__image--active');
            this.$elem.find('.testimonial[data-testimonial="' + index + '"]').addClass('testimonial--active');
        }
    };
    Testimonial.init($('.testimonials'));
})();
